import defaultHeaders from '../apiConfig';
import { callService } from '../apiService';

export async function userStatusService(payload) {
  try {
    let request = {
      url: '/services/user/user',
      type: 'GET',
      headers: defaultHeaders,
    };
    request.headers.Authorization = payload.authorization;
    const { error, response } = await callService(request);
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}
